<template>
  <div class="store-list">
    <div class="searchBox">
      <Form label-position="left" inline :model="searchValue">
        <FormItem label="商家名称" :label-width="70">
          <Input v-model="searchValue.username" class="input" clearable placeholder="输入商家名称" />
        </FormItem>
        <FormItem style="margin-left: 60px" label="商品架名称" :label-width="85">
          <Input v-model="searchValue.title" class="input" clearable placeholder="输入商品架名称" />
        </FormItem>
        <FormItem style="margin-left: 60px">
          <Button type="primary" icon="ios-search" @click="onSearch">搜索</Button>
        </FormItem>
      </Form>
    </div>
    <div class="content">
      <Table
        tooltip-theme="light"
        max-height="1000"
        highlight-row
        :loading="loading"
        :columns="columns"
        :data="data"
      >
        <template slot-scope="{ row, index }" slot="action">
          <Button
            type="primary"
            size="small"
            style="margin-right: 5px"
            @click="showQRcode(row.link)"
          >预览</Button>
        </template>
      </Table>
    </div>
    <div class="pageBox cardBox">
      <Page :current="current" :total="total" :page-size="limit" simple @on-change="changePage" />
    </div>
    <!-- 二维码组件 -->
    <qrCode v-if="qrShow" :link="qrLink" @close="qrShow = false" />
  </div>
</template>

<script>
import axios from "axios";
import { commodityList } from "@/service/api";
// 二维码
import qrCode from "@/components/qrCode.vue";

export default {
  components: { qrCode },
  data() {
    return {
      loading: false,
      total: 0,
      current: 1,
      limit: 10,
      searchValue: {},
      columns: [
        {
          title: "ID",
          key: "merchantId",
          sortable: true,
          // fixed: "left",
          width: 120,
        },
        {
          title: "商家名称",
          key: "merchantName",
          // sortable: true,

          width: 120,
        },
        {
          title: "标题",
          key: "title",
          // sortable: true,
          width: 200,
        },
        {
          title: "总流水",
          key: "totalFlow",
          //  slot: 'totalFlow',
          sortable: true,
          width: 120,
          render: (h, params) => {
            return h("div",params.row.income);
          },
        },
        {
          title: "分成比例",
          key: "shareRatio",
          // sortable: true,
          width: 120,
        },
        {
          title: "创建时间",
          key: "createTime",
          sortable: true,
          width: 200,
        },
        {
          title: "操作",
          key: "menu",
          slot: "action",
          fixed: "right",
          width: 80,
        },
      ],
      data: [],
      // 二维码
      qrLink: "",
      qrShow: false,
    };
  },
  mounted() {
    console.log(this.$route.query.merchant);
    let merchant = this.$route.query.merchant;
    if (merchant) {
      this.searchValue.username = merchant;
    }
    this.getData();
  },
  methods: {
    showQRcode(link) {
      this.qrLink = link;
      this.qrShow = true;
    },
    getData() {
      this.loading = true;
      let params = {
        page: this.current,
        limit: this.limit,
        title: this.searchValue.title,
        username: this.searchValue.username,
        invite: window.sessionStorage.getItem("inviteCode"),
      };
      commodityList(params)
        .then((res) => {
          this.loading = false;

          console.log("res:", res);
          if (res.data.code == 0) {
            let data = res.data.data;
            this.total = data.count;
            this.data = data.list.map((item) => {
              let totalFlow = Number(item.income);
              if (!totalFlow) {
                let num = item.income.replace(/[","]/gi, "");
                totalFlow = Number(num);
              }
              console.log(totalFlow);
              return {
                merchantId: item.id,
                merchantName: item.username,
                title: item.title,
                totalFlow: totalFlow,
                income: item.income,
                createTime: item.created_at,
                QRcode: item.pic,
                link: item.link,
                shareRatio: item.scale,
              };
            });
          } else {
            this.$Message.error({
              duration: 3,
              background: true,
              content: res.data.msg || "操作失败！",
            });
          }
        })
        .catch((error) => {
          console.log("error: ", error);
        });
    },
    onSearch() {
      console.log("searchValue:", this.searchValue);
      this.current = 1;
      this.getData();
    },
    changePage(page) {
      console.log(page);
      this.current = page;
      this.getData();
    },
  },
};
</script>

<style lang="less" scoped>
.store-list {
  flex: 1;
  margin-top: 30px;
  > .content {
    background-color: #fff;
    border-radius: 3px;
    box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.05);
    width: 100%;
    box-sizing: border-box;
  }
  .pageBox {
    padding: 10px 0;
    margin-top: 2px;
    /deep/ .ivu-page .ivu-page-simple-pager input {
      padding: 5px;
    }
  }
  .searchBox {
    padding: 20px 0;
    .input {
      width: 200px;
    }
  }
}
.poptipTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.QRcodeImg {
  width: 250px;
  height: 250px;
  object-fit: cover;
}
</style>